import pdpSlider from "./rbmc.pdp-slider";
import productDetails from "./rbmc.pdp";
import pdpCustomPersonalization from "./rbmc.pdp-custom-personalization";
import pdpConfig from "./rbmc.pdp-configurator-field";
import pdpAddToCart from './rbmc.pdp-add-to-cart';

const pdpPlayerPersonalization = {
    selectPlayerOption:        undefined,
    selectPlayerOptionWrapper: undefined,
    personalizeImageLoaded:    false,
    selectPlayerNameOption(clickedIndex) {
        const name   = pdpPlayerPersonalization.selectPlayerOption.find(`option:nth(${clickedIndex})`).data('name'),
              number = pdpPlayerPersonalization.selectPlayerOption.find(`option:nth(${clickedIndex})`).data('num');

        function exchangeImageUrl() {
            if (productDetails.cdnUrl) {
                pdpConfig.setCustomizedImageUrl(
                        [pdpConfig.personalizeImage, pdpConfig.personalizeMobileImage],
                        productDetails.cdnUrl, name, number);
            }
        }

        // needed due introduction of lazy loaded images
        if (pdpPlayerPersonalization.personalizeImageLoaded || pdpConfig.firstTimePersonalized) {
            exchangeImageUrl();
        } else {
            pdpSlider.pdpSliderWrapper.on('lazyLoaded', function () {
                exchangeImageUrl();
                pdpPlayerPersonalization.personalizeImageLoaded = true;
            });
        }

        pdpSlider.goToPersonalizedSlide();
        pdpAddToCart.setPersonalization(name, number, 'PREDEFINED');
    },

    personalizationPlayerChoose() {
        pdpPlayerPersonalization.selectPlayerOption.on('changed.bs.select',
                function (e, clickedIndex, isSelected, previousValue) {
                    pdpPlayerPersonalization.setPlayerPersonalization(clickedIndex);
                });
    },

    setPlayerPersonalization(clickedIndex) {
        if (pdpConfig.customNameFlag) {
            pdpPlayerPersonalization.selectPlayerOption.parent().tooltip('show');
            const selectPlayerTooltip = $('#pdp__tooltip-select-player');
            selectPlayerTooltip.on('click', '.pdp__tooltip-confirm', function () {
                pdpConfig.playerChosenFlag = true;
                pdpCustomPersonalization.resetNameAndNumberChoice();
                pdpPlayerPersonalization.selectPlayerNameOption(clickedIndex);
                pdpPlayerPersonalization.selectPlayerOption.parent().tooltip('hide');
                pdpPlayerPersonalization.selectPlayerOptionWrapper.find('.pdp__icon-reset').removeClass('d-none');
            });
            selectPlayerTooltip.on('click', '.pdp__tooltip-cancel', function () {
                pdpPlayerPersonalization.selectPlayerOption.parent().tooltip('hide');
                pdpPlayerPersonalization.selectPlayerOption.prop("selectedIndex", 1);
                pdpPlayerPersonalization.selectPlayerOption.selectpicker('refresh');
            });
        } else {
            pdpCustomPersonalization.resetNameAndNumberChoice();
            pdpPlayerPersonalization.selectPlayerNameOption(clickedIndex);
            pdpPlayerPersonalization.selectPlayerOptionWrapper.find('.pdp__icon-reset').removeClass('d-none');
            pdpConfig.customNameFlag   = false;
            pdpConfig.playerChosenFlag = true;
        }
    },

    resetPdpPlayerSelectChoice() {
        pdpPlayerPersonalization.selectPlayerOptionWrapper.find('.pdp__icon-reset').addClass('d-none');
        pdpConfig.restoreOriginalImageSrc();
        pdpPlayerPersonalization.selectPlayerOption.prop("selectedIndex", 1);
        pdpPlayerPersonalization.selectPlayerOption.selectpicker('refresh');
        pdpConfig.playerChosenFlag = false;
        pdpAddToCart.setPersonalization('', '', '');
    },

    cacheSelectors() {
        pdpPlayerPersonalization.selectPlayerOption        = $('#pdp__select-player');
        pdpPlayerPersonalization.selectPlayerOptionWrapper = $('.pdp__select-player-wrapper');
    },

    init() {
        pdpPlayerPersonalization.cacheSelectors();
        pdpPlayerPersonalization.personalizationPlayerChoose();
    }
};

export default pdpPlayerPersonalization;